import type * as React from 'react'

import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import clsx from 'clsx'

import styles from './css/SortableThreadItem.module.css'

interface SortableThreadItemProps {
  id: string
  index: number
  children: React.ReactNode
  disabled?: boolean
  isActiveThread?: boolean
}

export const SortableThreadItem: React.FC<SortableThreadItemProps> = ({
  id,
  index,
  children,
  disabled = false,
  isActiveThread = false,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id,
    disabled,
    transition: null,
  })

  const style = {
    transform: CSS.Transform.toString(transform && { ...transform, scaleY: 1 }),
    transition,
  }

  const containerClassName = clsx(styles.sortableItemContainer, {
    [styles.dragging]: isDragging,
    [styles.flexOne]: isActiveThread,
    [styles.flexNone]: !isActiveThread,
    [styles.cursorText]: isActiveThread,
    [styles.cursorDefault]: disabled && !isActiveThread,
    [styles.cursorGrab]: !disabled && !isActiveThread,
  })

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={containerClassName}
      {...attributes}
      {...listeners}
    >
      {children}
    </div>
  )
}
